export default __webpack_public_path__ + "static/media/mysticalbane4.0fcf38ec.png";